import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import ModalOverlay from '../ModalOverlay/ModalOverlay.tsx';
import MiCuenta from '../../Perfil/PerfilMain/MiCuenta/MiCuenta';
import styles from './AccountSettingsModal.module.scss';

interface AccountSettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  setInfoReady: (ready: boolean) => void;
}

const modalVariants = {
  hidden: { opacity: 0, scale: 0.95, y: 20 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.3,
    },
  },
};

const AccountSettingsModal: React.FC<AccountSettingsModalProps> = ({
  isOpen,
  onClose,
  setInfoReady,
}) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay isOpen={isOpen} onClose={onClose} zIndex={3}>
      <motion.div
        className={styles.modal}
        variants={modalVariants}
        initial="hidden"
        animate="visible"
        exit="hidden"
      >
        <div className={styles.modalHeader}>
          <h2 className={styles.modalHeader_title}>Configuración de la cuenta</h2>
          <button
            className={styles.modalHeader_close}
            onClick={onClose}
            aria-label="Cerrar configuración"
          >
            <X size={24} />
          </button>
        </div>
        
        <div className={styles.modalContent}>
          <MiCuenta
            setInfoReady={setInfoReady}
          />
        </div>
      </motion.div>
    </ModalOverlay>
  );
};

export default AccountSettingsModal;

